import React from "react";
import { useTranslation } from "react-i18next";

import { Typography } from "antd";

const DrawSection = () => {
    const { t } = useTranslation();

    return (
        <Typography.Paragraph type="secondary" className="mb-0">
            {t("signatureImageDescription")} <br /> {t("note")}: {t("signatureImageDrawingTip")}.
        </Typography.Paragraph>
    );
};

export default DrawSection;
